module.exports = __webpack_public_path__ + "static/img/prproj.2594120.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_suffix/prproj.png
// module id = DlXu
// module chunks = 53